Ext.define('SA.view.ImportCancelConfirmation', {
    alias: 'widget.import-cancel-confirmation',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-import-cancel-confirmation',
    includeHeader: false,

    getBodyItems() {
        return {
            xtype: 'component',
            cls: 'sa-import-cancel-confirmation-message-wrap',

            html: [
                '<svg class="sa-import-cancel-confirmation-svg"><use href="#sa-icon-warning"></use></svg>',
                '<div class="sa-import-cancel-confirmation-message">Are you sure you wish to cancel this data import?</div>'
            ]
        };
    },

    getFooterItems() {
        return [{
            xtype: 'sa-button',
            cls: 'sa-import-cancel-confirmation-no-btn',
            handler: () => this.destroy(),
            text: 'No',
            ui: 'primary',
            width: 64
        }, {
            xtype: 'sa-button',
            handler: () => this.onYesClick(),
            text: 'Yes, cancel import'
        }];
    },

    onYesClick() {
        this.onCancelConfirmed();

        this.destroy();
    }
});